import React from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Chip,
  Slider,
  Stack,
  Typography,
} from "@mui/material";
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";

const CardDecesso = ({ vitaGaranzie, onSliderChange }) => {
  return (
    <Card
      sx={{
        mb: 2,
        background: "linear-gradient(135deg, #13b86d, #10ac7d)",
        color: "white",
        borderRadius: 3,
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={2}
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <Avatar sx={{ bgcolor: "rgba(255,255,255,0.3)" }}>
              <FavoriteRoundedIcon />
            </Avatar>
            <Box>
              <Typography variant="h6" fontWeight={700}>
                Decesso
              </Typography>
              <Typography variant="caption" sx={{ opacity: 0.9 }}>
                Durata: {vitaGaranzie.decesso.durata} anni - Capitale:{" "}
                {vitaGaranzie.decesso.capitale.toLocaleString()}€
              </Typography>
            </Box>
          </Stack>
          <Box textAlign="right">
            <Typography variant="h4" fontWeight={700}>
              180.00€
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.9 }}>
              all'anno
            </Typography>
          </Box>
        </Box>

        <Box sx={{ mb: 3, px: 2 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={1}
          >
            <Typography variant="body2" fontWeight={600}>
              Durata
            </Typography>
            <Typography variant="body2" fontWeight={700}>
              {vitaGaranzie.decesso.durata} anni
            </Typography>
          </Box>
          <Slider
            value={vitaGaranzie.decesso.durata}
            onChange={onSliderChange("decesso", "durata")}
            min={5}
            max={20}
            step={1}
            sx={{
              color: "white",
            }}
          />
          <Box display="flex" justifyContent="space-between" mt={0.5}>
            <Typography
              variant="caption"
              sx={{ color: "rgba(255,255,255,0.7)" }}
            >
              5 anni
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: "rgba(255,255,255,0.7)" }}
            >
              20 anni
            </Typography>
          </Box>
        </Box>

        <Box sx={{ px: 2 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={1}
          >
            <Typography variant="body2" fontWeight={600}>
              Capitale assicurato ai tuoi cari
            </Typography>
            <Chip
              label={`${vitaGaranzie.decesso.capitale.toLocaleString()} €`}
              sx={{
                bgcolor: "rgba(255,255,255,0.3)",
                color: "white",
                fontWeight: 700,
              }}
            />
          </Box>
          <Slider
            value={vitaGaranzie.decesso.capitale}
            onChange={onSliderChange("decesso", "capitale")}
            min={50000}
            max={300000}
            step={10000}
            sx={{
              color: "white",
            }}
          />
          <Box display="flex" justifyContent="space-between" mt={0.5}>
            <Typography
              variant="caption"
              sx={{ color: "rgba(255,255,255,0.7)" }}
            >
              50.000 €
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: "rgba(255,255,255,0.7)" }}
            >
              300.000 €
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CardDecesso;
